<ng-template #htmlContent>
  <div [style.minWidth]="'175px'" class="p-1">
    <table class="w-100">
      <thead>
        <tr>
          <th scope="col" class="mt-1 mb-1 text-info">Supported Files</th>
        </tr>
      </thead>
      <tbody>
        @for (item of accept; track $index) {
          <tr class="text-start">
            <td>{{ item }}</td>
          </tr>
        }
      </tbody>
    </table>
    @if (isImageFilter) {
      <div class="text-start">{{ 'fileSizeLimitExceed' | translate: { LIMIT_SIZE: maxSizeMB || 10 } }}</div>
    }
  </div>
</ng-template>

<div
  #container
  [ngClass]="{ 'compact-style': compactStyle }"
  class="upload-link text-center d-flex flex-column justify-content-center align-items-center a-min-height h-100 position-relative drop-zone"
  [class.on-drag-file]="isDragFile"
  [class.rounded-circle]="isRoundedCircle"
  [class.drag-border-color]="isDragFile"
  [class.p-0]="container.offsetHeight < 115"
  (click)="upload()"
  (keydown)="onKeyDown($event)"
  data-bs-toggle="tooltip"
  placement="top"
  container="body"
  [ngbTooltip]="htmlContent"
  [style.cursor]="disabled ? 'not-allowed' : 'pointer'"
  (dragenter)="ng2FileDropEnter($event)"
  (dragover)="ng2FileDropHoverStart($event)"
  (dragleave)="ng2FileDropHoverEnd($event)"
  (drop)="onNativeDrop($event)">
  @if (!compactStyle) {
    <div class="d-block custom-width">
      @if (!isDragFile && !(imageURL && imageURL !== '') && !isProjectV2) {
        <i class="fa fa-upload fa-3x grey" aria-hidden="true"></i>
      }
      <!-- @if (!isDragFile && !(imageURL && imageURL !== '') && !isProjectV2) {
        <img class="mt-3" src="assets/img/selection-grid-edit/browse-file.svg" alt="" />
      } -->
      @if (isProjectV2 && !imageURL) {
        <img class="mt-3" src="assets/img/selection-grid-edit/browse-file-black.svg" alt="" />
      }
      @if (isDragFile && !(imageURL && imageURL !== '') && !isProjectV2) {
        <i class="fa fa-plus-square fa-3x text-success" aria-hidden="true"></i>
      }
      @if (isProjectV2 && !imageURL) {
        <h6 class="_700 project-v2-file-drag-title mt-1">{{ 'Illustration' | translate }},</h6>
      }
      @if (isProjectV2 && !imageURL) {
        <p class="_700 project-v2-file-drag-title">{{ 'logoOrPicture' | translate }} </p>
      }
      @if (!(imageURL && imageURL !== '') && !isProjectV2) {
        <h6 class="text-uppercase grey">{{ inputText || ('dragAndDropSelectFilesText' | translate) }}</h6>
      }
      @if (!(imageURL && imageURL !== '') && !isProjectV2) {
        <p
          class="text-uppercase font-weight-bold grey mb-1"
          [innerHtml]="secondaryText ? secondaryText : ('dragAndDropOrDragText' | translate)"></p>
      }
      @if (!!imageURL) {
        <img
          [hidden]="isRedirectImageLoadError && isImageLoadError"
          class="area-background-image"
          [src]="imageURL"
          alt=""
          (error)="onImageLoadError()"
          [class.drag-border-color]="isDragFile" />
      }
    </div>
  }
  @if (compactStyle) {
    <div class="d-block">
      <div class="d-flex align-items-center">
        <div class="me-3">
          @if (!isDragFile && !(imageURL && imageURL !== '')) {
            <i class="fa fa-upload fa-3x" aria-hidden="true"></i>
          }
          @if (isDragFile && !(imageURL && imageURL !== '')) {
            <i class="fa fa-plus-square fa-3x text-success" aria-hidden="true"></i>
          }
        </div>
        <div class="d-flex flex-column">
          @if (!(imageURL && imageURL !== '')) {
            <h5 class="text-start text-uppercase mt-3"
              >{{ inputText || ('dragAndDropSelectFilesText' | translate) }}
            </h5>
          }
          @if (!(imageURL && imageURL !== '')) {
            <p
              class="ttext-start text-uppercase font-weight-bold"
              [innerHtml]="secondaryText ? secondaryText : ('dragAndDropOrDragText' | translate)"></p>
          }
        </div>
      </div>
      @if (!!imageURL) {
        <img
          [hidden]="isRedirectImageLoadError && isImageLoadError"
          class="area-background-image"
          [src]="imageURL"
          alt=""
          (error)="onImageLoadError()"
          [class.drag-border-color]="isDragFile" />
      }
    </div>
  }
</div>
<input #fileInput class="input-file" type="file" multiple (change)="fileChangeListener($event)" [disabled]="disabled" />
